import jQuery from 'jquery';
import AddToCartFlyout from './AddToCartFlyout';
import Forms from './Forms';
import MessageBanner from './MessageBanner';
import Modal from './Modal';
import PaymentTerms from './PaymentTerms';
import ProductGallery from './ProductGallery';
import ShopifyVariantsUI from './ShopifyVariantsUI';
import SurfacePickUp from './SurfacePickUp';
import { FormatMoney } from '@components/Shared/Utils/price';
export default class ProductDetails {
    constructor(options) {
        var _a, _b;
        this.$window = jQuery(window);
        this.$formArea = options.$formArea;
        this.$details = options.$details;
        this.context = options.context;
        this.settings = options.settings;
        this.product = options.product;
        this.useHistory = options.useHistory;
        this.sectionId = options.sectionId;
        this.productEl = options.productEl;
        this.initialVariant = options.initialVariant || null;
        this.paymentTerms = new PaymentTerms(this.productEl);
        if (this.product) {
            if ('media' in this.product) {
                this.gallery = new ProductGallery({
                    el: options.gallery,
                    sectionContext: options.sectionContext,
                    settings: this.settings,
                    isQuickshop: options.isQuickshop,
                });
            }
        }
        if (!jQuery(this.$formArea).length)
            return;
        this.variantsUI = new ShopifyVariantsUI(this.$formArea.get(0).querySelector('[data-variants-ui]'), this.product, {
            selectFirstAvailableVariant: this.settings.select_first_available_variant,
            disableUnavailableOptions: this.settings.sold_out_options === 'disabled',
            removeUnavailableOptions: this.settings.sold_out_options === 'hidden',
        });
        this.addToCartFlyout = null;
        this.atcCallbacks = options.atcCallbacks;
        this._modalRequestCallback = this._modalRequestCallback.bind(this); // Form
        this.$form = this.$formArea.find('[data-product-form]');
        this.$productAtcButton = this.$formArea.find('[data-product-atc]');
        this.$productVariants = this.$form.find('[data-variants]');
        this.$productOptions = this.$form.find('[data-product-option]');
        this.productPricing = this.$details[0].querySelector('[data-product-pricing]');
        this.detailsLink = this.$formArea[0].querySelector('[data-product-details-link]');
        if (this.detailsLink) {
            this.detailsBaseHref = this.detailsLink.getAttribute('href');
        }
        this.variantFields = {
            $priceContainer: this.$details.find('[data-price-container]'),
            $priceMoney: this.$details.find('[data-price-container] [data-price]'),
            $compareAtPrice: this.$details.find('[data-price-compare-container]'),
            $compareAtPriceMoney: this.$details.find('[data-price-compare-container] [data-price-compare]'),
            $badge: this.$details.find('[data-badge-sales]'),
            $badgeRange: this.$details.find('[data-badge-sales-range]'),
            $badgeSingle: this.$details.find('[data-badge-sales-single]'),
            $sku: this.$details.find('[data-product-sku]'),
            unitPrice: this.$details[0].querySelector('[data-unit-price]'),
            totalQuantity: this.$details[0].querySelector('[data-total-quantity]'),
            unitPriceAmount: this.$details[0].querySelector('[data-unit-price-amount]'),
            unitPriceMeasure: this.$details[0].querySelector('[data-unit-price-measure]'),
            taxLine: this.$details[0].querySelector('[data-tax-line]'),
            hiddenComparePrice: this.$details[0].querySelector('[data-compare-price-hidden]'),
            hiddenCurrentPrice: this.$details[0].querySelector('[data-current-price-hidden]'),
            hiddenComparePriceRange: this.$details[0].querySelector('[data-compare-price-range-hidden]'),
            hiddenCurrentPriceRange: this.$details[0].querySelector('[data-current-price-range-hidden]'),
        };
        this.forms = new Forms(this.$form);
        if (this.product) {
            this._bindEvents();
            this._initOptions();
        }
        if (this.variantsUI.isInIndeterminateState) {
            this._showPriceRange();
        }
        (_b = (_a = this.variantsUI) === null || _a === void 0 ? void 0 : _a._shopifyVariants) === null || _b === void 0 ? void 0 : _b._updateOptions();
    }
    unload() {
        if (this.variantsUI) {
            this.variantsUI.offVariantChange((data) => this._switchVariant(data));
            this.variantsUI.unload();
        }
        if (this.$form) {
            this.$form.off(`.product-details-${this.sectionId}`);
        }
        if (this.forms) {
            this.forms.unload();
        }
        if (this.gallery) {
            this.gallery.unload();
        }
        if (this.messageBanner) {
            this.messageBanner.unload();
        }
    }
    _bindEvents() {
        this.variantsUI.onVariantChange((data) => this._switchVariant(data));
        // Add to cart
        // this.$form.on(`submit.product-details-${this.sectionId}`, (event) => this._addToCartFlyout(event));
    }
    _initOptions() {
        this.surfacePickUp = new SurfacePickUp(this.$formArea[0].querySelector('[data-surface-pick-up]'));
        this.modal = new Modal({
            onClose: () => this.modal.unload(),
            modalId: 1,
        });
        if (!this.variantsUI.isInIndeterminateState) {
            const { currentVariant } = this.variantsUI;
            this._updateBadge(currentVariant);
            this.surfacePickUp.load(currentVariant.id);
        }
        this.surfacePickUp.onModalRequest(this._modalRequestCallback);
    }
    _modalRequestCallback(contents) {
        const { isDefaultVariant, currentVariant } = this.variantsUI;
        let container = this.$formArea[0].querySelector('[data-surface-pick-up-modal-contents]');
        const variantTitle = !isDefaultVariant ? `<div class="surface-pick-up-modal__variant">${currentVariant.title}</div>` : '';
        const modalContents = `
      <div class="surface-pick-up-modal__header">
        <h2 class="surface-pick-up-modal__title">${this.product.title}</h2>
        ${variantTitle}
      </div>
      ${contents}
      `;
        if (!container) {
            container = document.createElement('div');
            container.setAttribute('data-surface-pick-up-modal-contents', '');
            container.style.display = 'none';
            container.innerHTML = modalContents;
            this.$formArea[0].appendChild(container);
        }
        else {
            container.innerHTML = modalContents;
        }
        this.modal.open('[data-surface-pick-up-modal-contents]', 'surface-pick-up');
    }
    _switchVariant(data) {
        const { currentVariant } = data;
        if (this.variantsUI.isInIndeterminateState) {
            this._showPriceRange();
            return;
        }
        if (this.productPricing) {
            if (!currentVariant) {
                this.productPricing.style.visibility = 'hidden';
            }
            else {
                this.productPricing.style.visibility = 'visible';
            }
        } // Update main select
        this.$productVariants.val(currentVariant.id);
        if (this.gallery) {
            this.gallery.selectMediaByVariant(currentVariant);
        }
        this.surfacePickUp.load(currentVariant.id); // Update Variant information
        // this._updatePrice(currentVariant);
        this._updateSKU(currentVariant);
        this._updateBadge(currentVariant);
        this._updateButton(currentVariant);
        this._updateSwatchLabel(currentVariant);
        this._updateFullDetailsLink(currentVariant);
        this._updateUnitPrice(currentVariant);
        this.paymentTerms.update(currentVariant.id);
        if (this.useHistory) {
            const url = `${globalThis.Shopify.routes.root}products/${this.product.handle}?${jQuery.param({
                variant: currentVariant.id,
            })}`;
            history.replaceState({}, 'variant', url);
        }
    }
    _updatePrice(variant) {
        if (!this.productPricing) {
            return;
        }
        const compareAtPrice = this.variantFields.hiddenComparePrice.innerHTML;
        const currentPrice = this.variantFields.hiddenCurrentPrice.innerHTML;
        this.variantFields.$compareAtPrice[0].innerHTML = compareAtPrice;
        this.variantFields.$priceContainer[0].innerHTML = currentPrice;
        this.variantFields.$priceMoney = this.$details.find('[data-price-container] [data-price]');
        this.variantFields.$compareAtPriceMoney = this.$details.find('[data-price-compare-container] [data-price-compare]'); // Update compare at price
        const hasComparePrice = !!variant.compare_at_price && variant.compare_at_price > variant.price;
        this.variantFields.$compareAtPrice.toggleClass('visible', hasComparePrice);
        this.variantFields.$compareAtPriceMoney.text(FormatMoney(variant.compare_at_price, this.settings.money_format)); // Update price
        this.variantFields.$priceMoney.text(FormatMoney(variant.price, this.settings.money_format));
    }
    _showPriceRange() {
        this._updateBadge(false);
        const currentPriceIsRange = this.product.price_varies;
        const currentCompareAtPriceIsRange = this.product.variants.some((variant) => (variant.compare_at_price || variant.price) !== this.product.compare_at_price);
        const currentPrice = currentPriceIsRange ? this.variantFields.hiddenCurrentPriceRange.innerHTML : this.variantFields.hiddenCurrentPrice.innerHTML;
        const compareAtPrice = currentCompareAtPriceIsRange
            ? this.variantFields.hiddenComparePriceRange.innerHTML
            : this.variantFields.hiddenComparePrice.innerHTML;
        const shouldDisplayCompareAtPrice = this.product.compare_at_price_max > this.product.price_min;
        this.variantFields.$compareAtPrice.toggleClass('visible', shouldDisplayCompareAtPrice);
        this.variantFields.$compareAtPrice[0].innerHTML = compareAtPrice;
        this.variantFields.$priceContainer[0].innerHTML = currentPrice;
    }
    _updateSKU(variant) {
        if (variant.sku === '') {
            this.variantFields.$sku.parent().addClass('product-sku--empty');
        }
        else {
            this.variantFields.$sku.parent().removeClass('product-sku--empty');
        }
        this.variantFields.$sku.text(variant.sku);
    }
    _updateBadge(variant = false) { }
    _updateButton(variant) { }
    _updateSwatchLabel(variant) {
        if (this.settings.swatches_enable) {
            const swatchLabel = this.$form[0].querySelector('[data-option-swatch-value]');
            if (swatchLabel) {
                swatchLabel.innerText = variant.options[parseInt(swatchLabel.dataset.optionSwatchValue, 10)];
            }
        }
    }
    _updateFullDetailsLink(variant) {
        if (this.detailsLink) {
            this.detailsLink.setAttribute('href', `${this.detailsBaseHref}?variant=${variant.id}`);
        }
    }
    _updateUnitPrice(variant) {
        if (this.variantFields.unitPrice && variant.unit_price_measurement) {
            this.variantFields.totalQuantity.innerHTML = `${variant.unit_price_measurement.quantity_value}${variant.unit_price_measurement.quantity_unit}`;
            this.variantFields.unitPriceAmount.innerHTML = FormatMoney(variant.unit_price, this.settings.money_format);
            if (variant.unit_price_measurement.reference_value === 1) {
                this.variantFields.unitPriceMeasure.innerHTML = variant.unit_price_measurement.reference_unit;
            }
            else {
                this.variantFields.unitPriceMeasure.innerHTML = `${variant.unit_price_measurement.reference_value}${variant.unit_price_measurement.reference_unit}`;
            }
            this.variantFields.unitPrice.classList.remove('hidden');
        }
        else if (this.variantFields.unitPrice) {
            this.variantFields.unitPrice.classList.add('hidden');
        }
        if (this.variantFields.taxLine) {
            if (variant.taxable) {
                this.variantFields.taxLine.classList.remove('hidden');
            }
            else {
                this.variantFields.taxLine.classList.add('hidden');
            }
        }
    }
    _addToCartFlyout(event) {
        event.preventDefault();
        if (!this.variantsUI.currentVariant) {
            this.messageBanner = new MessageBanner(this.context.select_variant, 'error');
            this.$form.get(0).classList.add('product-form--error-option-unselected');
            return;
        }
        if (this.addToCartFlyout) {
            this.addToCartFlyout.unload();
        }
        const formData = this.$form.serializeArray();
        const options = {
            atcButton: this.$productAtcButton[0],
            settings: {
                moneyFormat: this.settings.money_format,
                cartRedirection: this.settings.cart_redirection,
            },
        };
        this.addToCartFlyout = new AddToCartFlyout(formData, options, this.atcCallbacks);
    }
}
